import { createAction, createAsyncThunk, createEntityAdapter, createReducer } from "@reduxjs/toolkit";
import { IOnlineBookingEntity } from "models/OnlineBooking.model";
import { serviceContainer } from "services/serviceContainer";
import { RootState } from "store/types";
import { createDeepEqualSelector } from "store/utils";

const applicationBookingEntityAdapter = createEntityAdapter<IOnlineBookingEntity>({
  selectId: (entity) => entity.id,
});

export const initialState = applicationBookingEntityAdapter.getInitialState();

export const loadApplicationBooking = createAction<IOnlineBookingEntity[]>("domainData/application-booking/booking");

export const fetchApplicationBookings = createAsyncThunk(
  "domainData/application-booking/fetchApplicationBookings",
  async (applicationId: number) => {
    const bookingService = serviceContainer.cradle.onlineBookingService;
    const applicationBookings = await bookingService.fetchOnlineBookings({ applicationId });
    return applicationBookings;
  }
);

export const applicationBookingReducer = createReducer<typeof initialState>(initialState, (builder) =>
  builder
    .addCase(loadApplicationBooking, applicationBookingEntityAdapter.setAll)
    .addCase(fetchApplicationBookings.fulfilled, applicationBookingEntityAdapter.upsertMany)
);

export const { selectAll: selectAllApplicationBookingEntities } = applicationBookingEntityAdapter.getSelectors(
  (state: RootState) => state.domainData.applicationBookings
);

export const selectApplicationBookingsByApplicationId = createDeepEqualSelector(
  [(_: RootState, args: { applicationId: number }) => args, selectAllApplicationBookingEntities],
  (args, applicationBookings) => {
    return applicationBookings.filter((item) => item.applicationId === args.applicationId);
  }
);

export const selectInspectionBookingByInspectionId = createDeepEqualSelector(
  [(_: RootState, args: { inspectionBookingId: string }) => args, selectAllApplicationBookingEntities],
  (args, applicationBookings) => {
    const inspectionBooking = applicationBookings.find((item) => item.id === args.inspectionBookingId);
    return inspectionBooking;
  }
);
